<template>
  <v-container
    id="nomenclature-view"
    fluid
    tag="section"
  >
    <material-card
      dark
      icon="mdi-clipboard-text"
      icon-small
      title="Nomenclature Items"
      color="accent"
    >
      <template v-slot:headActions>
        <app-btn
          color="primary"
          dark
          class="ml-2"
          to="/nomenclature/new"
        >
          {{ $t('New Item') }}
        </app-btn>
      </template>
      <v-data-table
        :headers="headers"
        :loading="loading"
        :items="products"
      >
        <template v-slot:body="{ items }">
          <item
            v-for="item in items"
            :key="item.id"
            :item="item"
          />
        </template>
      </v-data-table>
    </material-card>
  </v-container>
</template>
<script>
  import { mapActions, mapGetters } from 'vuex'
  import Item from '@/components/Nomenclature/Item'

  export default {
    name: 'Nomenclature',
    components: {
      Item,
    },
    data: () => ({
      loading: false,
      headers: [
        { text: 'ID', align: 'center', width: '20%', value: 'id' },
        { text: 'Name', align: 'center', width: '20%', value: 'name' },
        { text: 'Growing Percentage', align: 'center', width: '20%', value: 'growing_percentage' },
        { text: 'Max Growing Age', align: 'center', width: '20%', value: 'max_growing_age' },
        { text: 'Created At', align: 'center', width: '20%', value: 'created_at' },
        { text: 'Is Active', align: 'center', width: '20%', sortable: false, value: '' },
        { text: 'Action', align: 'center', width: '20%', sortable: false, value: '' },
      ],
    }),
    computed: {
      ...mapGetters({
        products: 'nomenclature/getNomenclature',
      }),
    },
    mounted () {
      this.loading = true
      this.loadNomenclature()
        .finally(() => {
          this.loading = false
        })
    },
    methods: {
      ...mapActions({
        loadNomenclature: 'nomenclature/loadProducts',
      }),
    },
  }
</script>
